import { noticeList, noticeUpdate, noticePublic, getUserList } from '@/api';
import { FormModal, HeaderTitle, Operation, Thumbnails, UploadImage } from '@/components';
import { notEmptyObj, toDateTime } from '@/utils/utils';
import React, { useEffect, useState } from 'react';
import { message, Table, Modal, Row, Select, Spin, Col, InputNumber, Input } from 'antd';

function InfosTemplate() {
  const [flag, setFlag] = useState(false);
  const [lists, setLists] = useState([]);
  const [datas, setDatas] = useState({});
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [body, setBody] = useState({});

  const columns = [
    {
      width: 100,
      title: '模板编号',
      dataIndex: 'id',
      align: 'center',
    },
    {
      width: 100,
      title: '模板图片',
      dataIndex: 'iconUrl',
      align: 'center',
      render: e => <Thumbnails images={[e]} center />,
    },
    {
      width: 200,
      title: '模板内容',
      dataIndex: 'content',
      align: 'center',
      ellipsis: true,
    },
    {
      width: 100,
      title: '微信推送',
      dataIndex: 'wechatPush',
      align: 'center',
    },
    {
      width: 100,
      title: '短信推送',
      dataIndex: 'smsPush',
      align: 'center',
    },
    {
      width: 100,
      title: '站内推送',
      dataIndex: 'dataPush',
      align: 'center',
    },
    {
      width: 100,
      title: '分类数值',
      dataIndex: 'classify',
      align: 'center',
    },
    {
      width: 100,
      title: '分类名称',
      dataIndex: 'classifyName',
      align: 'center',
    },
    {
      width: 100,
      title: '种类数值',
      dataIndex: 'kind',
      align: 'center',
    },
    {
      width: 100,
      title: '种类名称',
      dataIndex: 'kindName',
      align: 'center',
    },
    {
      width: 100,
      title: '模板排序',
      dataIndex: 'sort',
      align: 'center',
    },
    {
      width: 100,
      title: '备注信息',
      dataIndex: 'remark',
      align: 'center',
      ellipsis: true,
    },
    {
      width: 100,
      title: '最近修改',
      dataIndex: 'updatedAt',
      align: 'center',
      render: e => toDateTime(e),
    },
    {
      width: 100,
      title: '创建时间',
      dataIndex: 'createdAt',
      align: 'center',
      render: e => toDateTime(e),
    },
    {
      width: 100,
      title: '操作',
      align: 'center',
      fixed: 'right',
      render: e => (
        <Operation
          listData={{
            update: () => setDatas(e),
          }}
        />
      ),
    },
  ];

  useEffect(() => {
    noticeList().then(res => {
      setLists(res);
    });
  }, [flag]);

  const formDataModal = [
    {
      name: 'iconUrl',
      label: '模板图片',
      rules: [{ required: true, message: '请选择模板图片' }],
      render: <UploadImage model="single" callBackString />,
    },
  ];

  const handleSubmit = param => {
    if (!param) {
      setDatas({});
      return;
    }
    noticeUpdate({
      body: {
        id: datas.id,
        iconUrl: param.iconUrl,
      },
    }).then(() => {
      message.success('修改成功');
      setDatas({});
      setFlag(e => !e);
    });
  };


  const handlePublicSubmit = async param => {
    console.log("body:", body)
    if (Object.values(body).filter(i => i).length < 3) {
      message.warning('请将数据填写完整');
      return;
    }
    try {
      setLoading(true);
      const res = await getUserList({
        query: {
          id: body.userId,
        },
      });
      if (res.data.length === 1) {
        await noticePublic({
          body,
        });
        message.success('添加成功');
        setVisible(false);
        setLoading(false);
        setBody({});
        // flagFn();
      } else {
        message.warning('输入的用户不存在！');
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };


  return (
    <>
      <HeaderTitle title="发布消息通知" onClick={() => setVisible(true)} />
      <Table
        bordered
        size="small"
        scroll={{ x: 800 }}
        columns={columns}
        dataSource={lists}
        pagination={false}
        rowKey={row => row.id}
      />
      <Modal
        destroyOnClose
        title="发布消息通知"
        visible={visible}
        confirmLoading={loading}
        onCancel={() => setVisible(false)}
        onOk={() => handlePublicSubmit()}
      >
        <Spin spinning={loading}>
          <Row style={{ display: 'flex', alignItems: 'center', padding: '10px 0' }}>
            <Col span={6} style={{ textAlign: 'right', paddingRight: '22px' }}>
              消息模板编号:
            </Col>
            <InputNumber
              min={1}
              precision={0}
              max={999999999}
              controls={false}
              placeholder="请输入消息模板编号"
              style={{ width: '280px' }}
              onChange={e => {
                setBody(his => {
                  const newHis = Object.assign({}, his);
                  newHis.id = e;
                  return newHis;
                });
              }}
            />
          </Row>
          {/* <Row style={{ display: 'flex', alignItems: 'center', padding: '10px 0' }}>
            <Col span={6} style={{ textAlign: 'right', paddingRight: '22px' }}>
              认购类型:
            </Col>
            <Select
              placeholder="请选择认购类型"
              style={{ width: '280px' }}
              onChange={e => {
                setBody(his => {
                  const newHis = Object.assign({}, his);
                  newHis.kind = e;
                  return newHis;
                });
              }}
            >
              {Object.keys(kindObj).map(item => (
                <Select.Option key={item} value={item}>
                  {kindObj[item]}
                </Select.Option>
              ))}
            </Select>
          </Row> */}
          <Row style={{ display: 'flex', alignItems: 'center', padding: '10px 0' }}>
            <Col span={6} style={{ textAlign: 'right', paddingRight: '22px' }}>
              用户编号:
            </Col>
            <InputNumber
              min={0}
              precision={0}
              max={999999999}
              controls={false}
              placeholder="请输入用户编号,不输入发送所有用户"
              style={{ width: '280px' }}
              onChange={e => {
                setBody(his => {
                  const newHis = Object.assign({}, his);
                  newHis.userId = e;
                  return newHis;
                });
              }}
            />
          </Row>
          <Row style={{ display: 'flex', alignItems: 'center', padding: '10px 0' }}>
            <Col span={6} style={{ textAlign: 'right', paddingRight: '22px' }}>
              消息内容:
            </Col>
            <Input
              // min={0}
              precision={3}
              placeholder="请输入消息内容"
              style={{ width: '280px' }}
              onChange={e => {
                let value = e?.target?.value
                setBody(his => {
                  const newHis = Object.assign({}, his);
                  newHis.content = value;
                  return newHis;
                });
              }}
            />
          </Row>
        </Spin>
      </Modal>
      <FormModal
        title="修改模板"
        visible={!!notEmptyObj(datas)}
        formData={formDataModal}
        initialValues={datas}
        onChange={handleSubmit}
      />
    </>
  );
}

export default InfosTemplate;
